import { render, staticRenderFns } from "./user-management-table.vue?vue&type=template&id=65155431&scoped=true&"
import script from "./user-management-table.vue?vue&type=script&lang=js&"
export * from "./user-management-table.vue?vue&type=script&lang=js&"
import style0 from "./user-management-table.vue?vue&type=style&index=0&id=65155431&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65155431",
  null
  
)

export default component.exports